import { render, staticRenderFns } from "./ProcessInstanceManage.vue?vue&type=template&id=e483c37a&scoped=true"
import script from "./ProcessInstanceManage.vue?vue&type=script&lang=js"
export * from "./ProcessInstanceManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e483c37a",
  null
  
)

export default component.exports